import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"extension-off","clipPath":"url(#clip0_2332_3831)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.50023 5H9.00023V4C9.00023 2.89543 9.89567 2 11.0002 2C12.1048 2 13.0002 2.89543 13.0002 4V5H19.0002V11H20.0002C21.1048 11 22.0002 11.8954 22.0002 13C22.0002 14.1046 21.1048 15 20.0002 15H19.0002L19 15.5M8.50023 5H8.00023L7.99023 4.99L8.50023 5ZM19 15.5L19.0002 16L19.01 16.01L19 15.5ZM3 6V9.53544C4.69615 9.77806 6 11.2368 6 13C6 14.7632 4.69615 16.2219 3 16.4646V21H7.53544C7.77806 19.3039 9.23676 18 11 18C12.7632 18 14.2219 19.3039 14.4646 21H18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M1 3L21 23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExtensionOff = Vue.extend<IconProps>({
  name: 'ExtensionOffIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'extension-off',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ExtensionOff;
